'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMostRecentTargetedMessageThread = undefined;

var _reselect = require('reselect');

var _getTargetedMessageThreads = require('./getTargetedMessageThreads');

var getMostRecentTargetedMessageThread = exports.getMostRecentTargetedMessageThread = (0, _reselect.createSelector)([_getTargetedMessageThreads.getTargetedMessageThreads], function (targetedMessageThreads) {
  return targetedMessageThreads ? targetedMessageThreads.first() : undefined;
});


//////////////////
// WEBPACK FOOTER
// ./js/threads/selectors/getMostRecentTargetedMessageThread.js
// module id = 968
// module chunks = 2 3